import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import IRDataGrid from 'features/IRWorkstation/components/Common/IRDataGrid';
import QuadPanel from 'features/IRWorkstation/components/Common/QuadPanel';

const columns = [
	{
		field: 'name',
		headerName: 'Name',
		flex: 1,
		minWidth: 140,
		sortable: false,
	},
	{
		field: 'title',
		headerName: 'Title',
		flex: 1,
		minWidth: 140,
		sortable: false,
	},
	{
		field: 'email',
		headerName: 'Email',
		flex: 1,
		minWidth: 180,
		sortable: false,
	},
];

const LPContactsCard = ({
	contacts,
	loading,
	loadingMore,
	hasMore,
	error,
	loadMore,
}) => (
	<Box
		data-testid='lp-contacts-card'
		sx={{ width: '100%', minWidth: 0, display: 'flex', '& > *': { flex: 1 } }}
	>
		<QuadPanel title='Contacts'>
			{error ? (
				<Box
					sx={{
						minHeight: 200,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<Typography color='error' sx={{ fontSize: '12px' }}>
						Unable to load Contact records
					</Typography>
				</Box>
			) : (
				<IRDataGrid
					rows={contacts}
					columns={columns}
					loading={loading}
					loadingMore={loadingMore}
					hasMore={hasMore}
					onRowsScrollEnd={loadMore}
					scrollEndThreshold={100}
					noRowsMessage='No Contact records'
					minHeight={204}
					maxHeight={204}
					dataTestId='lp-contacts-grid'
				/>
			)}
		</QuadPanel>
	</Box>
);

LPContactsCard.propTypes = {
	contacts: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			name: PropTypes.string,
			title: PropTypes.string,
			email: PropTypes.string,
		})
	).isRequired,
	loading: PropTypes.bool.isRequired,
	loadingMore: PropTypes.bool.isRequired,
	hasMore: PropTypes.bool.isRequired,
	error: PropTypes.string,
	loadMore: PropTypes.func.isRequired,
};

export default LPContactsCard;
